<template>
  <v-layout :loading="loading">
    <div
      v-if="!loading"
      class="pb-14 md:pt-20 sm:pb-36 pt-10"
    >
      <div class="container">
        <h1 class="title-1 mb-12 text-center">
          My favorite clusters
        </h1>

        <div class="md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-8 grid">
          <v-cluster-item
            v-for="cluster in clusters"
            :key="cluster.id"
            :cluster="cluster"
            @fetch="fetch()"
          />
        </div>
      </div>
    </div>
  </v-layout>
</template>
<script>import clusterItemVue from "./cluster-item.vue";

export default {
  name: "v-favorite-clusters",
  components: {
    "v-cluster-item": clusterItemVue
  },
  data() {
    return {
      loading: false,
      clusters: []
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http.get(this.$laravel.route("api.clusters.index",{favorite_filter_active: true})).then(
        (response) => {
          this.clusters = response.data.data;
        }
      ).finally(()=> {
        this.loading = false;
      });
    },
  }
};
</script>
